import Hero from './components/Hero';
import ValuePillars from './components/ValuePillars';
import IndustryAlignment from './components/IndustryAlignment';
import Process from './components/Process';
import PositioningStatement from './components/PositioningStatement';
import CallToAction from './components/CallToAction';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <ValuePillars />
      <IndustryAlignment />
      <Process />
      <PositioningStatement />
      <CallToAction />
      <Footer />
    </div>
  );
}
